import type { DTechFileConfig } from '../types/DTechFileConfig';

/**
 * Configuration objects for legacy D-Tech RSS file types
 * Provides backward compatibility with existing DTech Customer Memory File format
 */
export const LEGACY_CONFIGS: Record<string, DTechFileConfig> = {
  
  DTECH_RSS_DEFAULT: {
    version: 'legacy',
    dtechDataType: 'Complete_Log', // Legacy file is essentially a truncated Complete_Log
    timeColumns: ['Date & Time'],
    expectedColumns: [
      'Inclination', 
      'Azimuth', 
      'Target Inclination', 
      'Target Azimuth',
      'String Speed (Avg)',
      'String Speed (Mag)', 
      'String Speed (Gyro)',
      'Stick Slip Ratio',
      'Shaft World Angle',
      'Turbine'
    ],
    signatureColumns: [
      'Motor Power', // Unique to legacy RSS format  
      'Demand %', // Unique to legacy RSS format
      'Steering Effectiveness' // Unique to legacy RSS format
    ],
    toolType: 'DTech',
    fileType: 'DTECH_RSS_DEFAULT', // Preserve existing enum value for compatibility
    dataType: 'timeseries',
    timestampFormat: 'DD/M/YYYY HH:mm:ss', // Legacy uses different date format
    signatureThreshold: 2 // Need at least 2 signature columns for confident detection
  }

};